"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const app_service_1 = require("../../commons/app.service");
const router_1 = require("@angular/router");
const material_1 = require("@angular/material");
const core_2 = require("@ngx-translate/core");
const main_service_1 = require("../main.service");
const rxjs_1 = require("rxjs");
const main_component_1 = require("../main.component");
const explorer_dialogs_1 = require("../../commons/dialogs/explorer.dialogs");
const _4d_mapper_1 = require("4d-mapper");
const AppBaseComponent_1 = require("../../commons/AppBaseComponent");
const application_events_service_1 = require("../../xs/services/events/application-events.service");
const Cesium = window.Cesium;
class JobComponent extends AppBaseComponent_1.AppBaseComponent {
    constructor(fourD, service, r, sn, d, ar, t, mainComponent, mainService, trans, applicationEvents) {
        super(service, r, sn, d, applicationEvents);
        this.fourD = fourD;
        this.service = service;
        this.r = r;
        this.ar = ar;
        this.t = t;
        this.mainComponent = mainComponent;
        this.mainService = mainService;
        this.trans = trans;
    }
    ngOnChanges(changes) {
        this.refresh();
    }
    refresh() {
        this.job.inputDatasets.useCache(true).queryObservable().subscribe();
        this.job.inputFolders.useCache(true).queryObservable().subscribe();
        setTimeout(() => this.job.jobType.subTransforms.useCache(true).queryObservable().subscribe(), 1000);
        this.batches = this.job.batches();
        this.batches.useCache(true).sortBy('dateMade', true).queryObservable().subscribe(res => this.initalTransform = res.items.find(cur => cur.transformType == this.job.jobType.baseTransform));
    }
    addDataset() {
        this.openDialogWithMode('file_all', "PROJECT.DIALOG.ADD_FOLDER_TITLE", "PROJECT.DIALOG.ADD_FOLDER_TEXT").subscribe(dest => {
            if (!dest)
                return;
            var itms = dest;
            rxjs_1.forkJoin(itms.map(d => this.job.inputDatasets.addObserveable(d))).subscribe(s => {
                this.openSnackBarSuccess('GENERIC.SAVED', null);
                this.job.inputDatasets.items.subscribe();
            }, e => this.openSnackBarError(e.message, null));
        }, e => this.openSnackBarError(e.message, null));
    }
    addFolder() {
        this.openDialogWithMode('folder', "PROJECT.DIALOG.ADD_FOLDER_TITLE", "PROJECT.DIALOG.ADD_FOLDER_TEXT")
            .subscribe(dest => {
            if (!dest)
                return;
            this.job.inputFolders.addObserveable(dest).subscribe(s => {
                this.openSnackBarSuccess(s + ' PROJECT.DIALOG.ITEMS_ADDED');
                this.job.inputFolders.items.subscribe();
            }, e => this.openSnackBarError(e));
        }, e => this.openSnackBarError(e.message, null));
    }
    runXForm(tt) {
        var onReady = null;
        onReady = tt['needsInput'] ? this.showInputDialogForT({}, tt) : rxjs_1.of({ model: {} });
        onReady.subscribe(params => {
            if (!params)
                return;
            this.job.startTransform(tt, params.model).subscribe(s => this.openSnackBarInfo(tt.name + ' PROJECT.DIALOG.STARTED'), e => this.openSnackBarError('GENERIC.ERROR ' + e.message));
        });
    }
    showInputDialogForT(model, tt) {
        let dialogRef = this.dialog.open(explorer_dialogs_1.APIDialog, {
            // height: '80%',
            data: { model: model, apis: [tt], title: 'TYPES.' + tt.uid }
        });
        return dialogRef.afterClosed();
    }
}
exports.JobComponent = JobComponent;
